class ApimApiClient {
	constructor(baseUrl, subscriptionKey) {
		this.baseUrl = baseUrl;
		this.subscriptionKey = subscriptionKey;

		if (!baseUrl) {
			throw new Error("Base URL is required");
		}
	}

	async fetch(endpoint, options = {}) {
		const headers = {
			"Content-Type": "application/json",
			"Ocp-Apim-Subscription-Key": this.subscriptionKey,
			...(options.headers || {}),
		};

		try {
			return fetch(this.baseUrl + endpoint, {
				...options,
				headers,
			});
		} catch (err) {
			console.error(`Unable to make request:`, {
				baseUrl: this.baseUrl,
				endpoint: this.endpoint,
				error: err,
			});

			return new Promise.reject("Unable to make request:", err);
		}
	}
}

export function createApimApiClient(baseUrl, subscriptionKey) {
	return new ApimApiClient(baseUrl, subscriptionKey);
}
